var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgForwardReply = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.5V9C4.477 9 0 13.477 0 19C0 19.273 0.0100002 19.543 0.0319996 19.81C1.495 17.036 4.362 15.119 7.687 15.005L8 15H10V19.5L18 12L10 4.5ZM16 4.5V7.237L21.08 12L16.001 16.761L16 19.5L24 12L16 4.5ZM12 9.116L15.076 12L12 14.883V13H7.966L7.619 13.007C6.334 13.05 5.095 13.317 3.943 13.773C5.41 12.075 7.58 11 10 11H12V9.116Z",
    fill: "#03053D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgForwardReply, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/forward-reply.ca6f21ec.svg";
export { ForwardRef as ReactComponent };